import { useEffect, useState } from "react";
import { getDoctorRecord } from "../../../../redux/Thunk/Doctor/DoctorThunks";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../Loader";
import Graph from "../../../common/Graph";
import RecordsData from "../../../common/RecordsData";

const Records = ({ DocID }) => {
  const dispatch = useDispatch();
  const { doctorRecord, loading } = useSelector((state) => state.doctor);
  const [rocords, setRecords] = useState([]);
  useEffect(() => {
    const id = DocID;
    dispatch(getDoctorRecord(id));
  }, [DocID, dispatch]);

  useEffect(() => {
    if (doctorRecord?.length > 0) {
      const publishedRecords = doctorRecord?.filter(
        (record) => record?.isPublish
      );
      setRecords(publishedRecords);
    }
  }, [doctorRecord]);

  return (
    <div className="tab-1">
      <Loader loading={loading} />
      {doctorRecord?.length > 0 ? (
        rocords?.map((record, i) => {
          const formattedDate = new Date(record?.date).toLocaleDateString(
            "en-GB"
          );
          return (
            <div className="bg-gray-100 p-5 mb-8 rounded-xl flex items-end flex-wrap">
              <div className="w-full xl:w-[calc(100%_-_480px)] xl:pr-[25px] max-xl:mb-3">
                <RecordsData
                  record={record}
                  formattedDate={formattedDate}
                  save={false}
                />
              </div>
              <div className="w-full xl:w-[480px]">
                <div className="bg-primary-50 rounded-[8px] py-2 px-4 shadow-[inset_0_4px_4px_rgba(0,0,0,0.18)]">
                  <Graph graphData={record?.detail} />
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="pt-5 text-gray-500">No record found</div>
      )}
    </div>
  );
};

export default Records;
